<template>
  <button type="button" tabindex="0" :title="labelText" :aria-label="labelText"
          class="btn btn-link social-media-icon p-0" @click="launchShare">
    <i class="icon-share" />
  </button>
</template>

<script>
import UrlSharingMixin from './url-sharing-mixin'

export default {
  mixins: [UrlSharingMixin],

  props: {
    utmMedium: {
      type: String,
      required: false
    }
  },

  computed: {
    labelText() {
      // Q: Shouldn't we use the A/B test text here?
      // A: No, because this button is not hooked up to the "A/B test complete" logic,
      //    which is about creating a campaign share click.
      return this.i18n.t('social.share_anywhere')
    },

    utmSource() {
      return 'web_share_api'
    }
  },

  methods: {
    launchShare() {
      navigator.share({
        url: this.urlToShareWithTracking()
      }).catch((error) => {
        if (error.name === 'AbortError') {
          // This means the user cancelled the share. This is not a problem we need to handle.
        } else {
          // Something else went wrong. Treat this as an error.
          throw error
        }
      })
    }
  }
}
</script>
